import { combineReducers } from '@reduxjs/toolkit';
import { ActionType } from '../types';
import { Types } from './actions';

const verifiedState = {
  status: null,
  error: null,
};

const verifyReducer = (state = verifiedState, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.VERIFY_SUCCESS:
      return {
        ...state,
        status: true,
        error: null,
      };
    case Types.VERIFY_FAILURE:
      return {
        ...state,
        status: false,
        error: null,
      };
    case Types.LOGOUT_AUTH:
      return {
        ...state,
        status: false,
        error: null,
      };
    case Types.VERIFY_ERROR:
      return {
        ...state,
        status: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

const userState = {};

const userReducer = (state = userState, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.SET_USER: {
      return action.payload.user;
    }
    case Types.LOGOUT_AUTH:
      return null;

    default:
      return state;
  }
};

const tokenReducer = (state = null, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.SET_TOKEN:
      return action.payload;
    case Types.LOGOUT_AUTH:
      return null;
    default:
      return state;
  }
};

const helpReducer = (state = null, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.SET_USER: {
      return action.payload.intercomHash || null;
    }
    case Types.LOGOUT_AUTH:
      return null;
    default:
      return state;
  }
  return state;
};

const reducer = combineReducers({
  token: tokenReducer,
  verified: verifyReducer,
  user: userReducer,
  help: helpReducer,
});

export default reducer;
